import { Container, Typography, Box, Grid, Paper } from "@mui/material";
import aboutImage from "../assets/images/dükkan.jpeg";

function About() {
  return (
    <Container sx={{ py: 8 }}>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Box
            component="img"
            src={aboutImage}
            alt="Fabrika"
            sx={{
              width: "100%",
              height: "auto",
            }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography variant="h5" gutterBottom>
            Anka Baskı: Kalite ve Güvenin Adresi
          </Typography>
          <Typography paragraph>
            2002 yılından bu yana tekstil baskı sektöründe faaliyet gösteren
            firmamız, müşterilerimize en kaliteli hizmeti sunmak için sürekli
            kendini yenilemektedir.
          </Typography>
          <Typography paragraph>
            Modern makine parkurumuz ve uzman kadromuzla, tekstil baskı alanında
            tüm ihtiyaçlarınıza profesyonel çözümler üretiyoruz.
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Box sx={{ mt: 4 }}>
            <Typography variant="h5" gutterBottom align="center">
              Neden Biz?
            </Typography>
            <Grid container spacing={3} sx={{ mt: 2 }}>
              {[
                {
                  title: "Kalite",
                  description: "En yüksek kalitede baskı hizmeti sunuyoruz.",
                },
                {
                  title: "Tecrübe",
                  description:
                    "Yılların verdiği tecrübe ile profesyonel hizmet.",
                },
                {
                  title: "Teknoloji",
                  description: "En son teknoloji makine parkuru.",
                },
                {
                  title: "Müşteri Memnuniyeti",
                  description: "Müşteri memnuniyeti odaklı çalışma prensibi.",
                },
              ].map((item) => (
                <Grid item xs={12} sm={6} md={3} key={item.title}>
                  <Paper elevation={3} sx={{ p: 3, height: "100%" }}>
                    <Typography variant="h6" gutterBottom>
                      {item.title}
                    </Typography>
                    <Typography>{item.description}</Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
}

export default About;
